

































import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { Questionnaire, QuestionnaireExtension } from "../../../../domain/format/objects";

type QuestionnaireExtensionKey = keyof QuestionnaireExtension;

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class QuestionnaireOtherExtensionEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: Questionnaire) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: Questionnaire) => T, defaultValue: T) => T;

  // 将来的に他のextensionも追加する可能性があるため、extensionKeyで管理する形にしている。
  private readonly _extensionKeys: QuestionnaireExtensionKey[] = ["valueString"];

  extensionKey: QuestionnaireExtensionKey = "valueString";
  extensionKeyOptions: StandardOption<QuestionnaireExtensionKey>[] = this._extensionKeys.map(t => new StandardOption(t, t));

  get extension(): QuestionnaireExtension[] {
    return this.readPropertyOrDefault(s => s.extension, undefined);
  }

  set extension(value: QuestionnaireExtension[]) {
    this.writePropertyWhenValid(s => s.extension = value);
  }

  addExtension() {
    const newExtension = this.createNewQuestionnaireExtension(this.extensionKey);
    this.extension = this.extension
      ? [...this.extension, newExtension]
      : [newExtension];
  }

  private createNewQuestionnaireExtension(extensionKey: QuestionnaireExtensionKey): QuestionnaireExtension {
    switch (extensionKey) {
      case "valueString":
        return new QuestionnaireExtension("", undefined, undefined, "");
      default:
        // 想定外の extensionKey が渡された場合は早期に検知できるよう例外を投げる
        throw new Error(`Unsupported QuestionnaireExtensionKey: ${extensionKey}`);
    }
  }

  updateUrl(index: number, value: string) {
    // URLとしての入力制限は保留。必要に応じて正規表現などで制限する。
    const matched = value.match(/\S*/g);
    this.updateExtension(index, c => c.url = matched ? matched.join("") : "");
  }

  updateValueString(index: number, value: string) {
    // 項目により入力制限が異なるため制限しないで値を受け取る。必要に応じて正規表現などで制限する。
    this.updateExtension(index, c => c.valueString = value);
  }

  private updateExtension(index: number, writer: (clone: QuestionnaireExtension) => void) {
    if (!this.extension || index < 0 || index >= this.extension.length) { return; }
    const clone = this.extension.map(e => e.clone());
    writer(clone[index]);
    this.extension = clone;
  }

  deleteExtension(index: number) {
    if (!this.extension || index < 0 || index >= this.extension.length) { return; }
    const updatedExtensions = this.extension.map(e => e.clone());
    updatedExtensions.splice(index, 1);
    this.extension = updatedExtensions.length > 0
      ? updatedExtensions
      : undefined;
  }
}
